import { IPaymentCheckFormCC, IPaymentCheckFormExt } from 'src/commons';
import { PaymentCheckActionTypes, PaymentCheckActions } from './payment-check.actions';

export interface State {
    error: string | null;
    pending: boolean;

    pendingValidateData: IPaymentCheckFormCC | null;
    forUploadData: IPaymentCheckFormCC | null;
    sentOeBSData: IPaymentCheckFormCC | null;

    pendingValidateFormCGData: IPaymentCheckFormExt | null;
    forUploadFormCGData: IPaymentCheckFormExt | null;
    sentOeBSFormCGData: IPaymentCheckFormExt | null;

    pendingValidateFormPPData: IPaymentCheckFormExt | null;
    forUploadFormPPData: IPaymentCheckFormExt | null;
    sentOeBSFormPPData: IPaymentCheckFormExt | null;

    pendingValidateFormESData: IPaymentCheckFormExt | null;
    forUploadFormESData: IPaymentCheckFormExt | null;
    sentOeBSFormESData: IPaymentCheckFormExt | null;

    // pendingValidateFormCIData: IPaymentCheckFormExt | null;
    // forUploadFormCIData: IPaymentCheckFormExt | null;
    // sentOeBSFormCIData: IPaymentCheckFormExt | null;
}

export const initialState: State = {
    error: null,
    pending: false,

    pendingValidateData: null,
    forUploadData: null,
    sentOeBSData: null,

    pendingValidateFormCGData: null,
    forUploadFormCGData: null,
    sentOeBSFormCGData: null,

    pendingValidateFormPPData: null,
    forUploadFormPPData: null,
    sentOeBSFormPPData: null,

    pendingValidateFormESData: null,
    forUploadFormESData: null,
    sentOeBSFormESData: null,

    // pendingValidateFormCIData: null,
    // forUploadFormCIData: null,
    // sentOeBSFormCIData: null,
};

export function reducer(state = initialState, action: PaymentCheckActions): State {
    switch (action.type) {

        // formCC
        case PaymentCheckActionTypes.LoadFormCCForValidateInvoiveState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCCForValidateInvoiveStateSuccess: {
            return {
                ...state,
                pending: state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                pendingValidateData: action.payload
            };
        }

        case PaymentCheckActionTypes.ValidateFormCC: {
            return {
                ...state,
                pending: true,
                error: 'Successfully validated!'
            }
        }

        case PaymentCheckActionTypes.LoadFormCCForUploadState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCCForUploadStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.pendingValidateData === null || state.sentOeBSData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                forUploadData: action.payload
            };
        }

        case PaymentCheckActionTypes.SendToOeBSFormCC: {
            return {
                ...state,
                pending: true,
                error: 'Successfully uploaded to OeBS!'
            }
        }

        case PaymentCheckActionTypes.LoadFormCCSentToOeBSState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCCSentToOeBSStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                sentOeBSData: action.payload
            };
        }

        // formCG
        case PaymentCheckActionTypes.LoadFormCGForValidateInvoiveState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCGForValidateInvoiveStateSuccess: {
            return {
                ...state,
                pending: state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                pendingValidateFormCGData: action.payload
            };
        }

        case PaymentCheckActionTypes.ValidateFormCG: {
            return {
                ...state,
                pending: true,
                error: 'Successfully validated!'
            }
        }

        case PaymentCheckActionTypes.LoadFormCGForUploadState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCGForUploadStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                forUploadFormCGData: action.payload
            };
        }

        case PaymentCheckActionTypes.SendToOeBSFormCG: {
            return {
                ...state,
                pending: true,
                error: 'Successfully uploaded to OeBS!'
            }
        }

        case PaymentCheckActionTypes.LoadFormCGSentToOeBSState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormCGSentToOeBSStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                sentOeBSFormCGData: action.payload
            };
        }

        // formPP
        case PaymentCheckActionTypes.LoadFormPPForValidateInvoiveState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormPPForValidateInvoiveStateSuccess: {
            return {
                ...state,
                pending: state.sentOeBSFormPPData === null || state.forUploadFormPPData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null,
                pendingValidateFormPPData: action.payload
            };
        }

        case PaymentCheckActionTypes.ValidateFormPP: {
            return {
                ...state,
                pending: true,
                error: 'Successfully validated!'
            }
        }

        case PaymentCheckActionTypes.LoadFormPPForUploadState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormPPForUploadStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null,
                forUploadFormPPData: action.payload
            };
        }

        case PaymentCheckActionTypes.SendToOeBSFormPP: {
            return {
                ...state,
                pending: true,
                error: 'Successfully uploaded to OeBS!'
            }
        }

        case PaymentCheckActionTypes.LoadFormPPSentToOeBSState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormPPSentToOeBSStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormPPData === null || state.forUploadFormPPData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormESData === null || state.sentOeBSFormESData === null || state.forUploadFormESData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null,
                sentOeBSFormPPData: action.payload
            };
        }

        // formES
        case PaymentCheckActionTypes.LoadFormESForValidateInvoiveState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormESForValidateInvoiveStateSuccess: {
            return {
                ...state,
                pending: state.sentOeBSFormESData === null || state.forUploadFormESData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                pendingValidateFormESData: action.payload
            };
        }

        case PaymentCheckActionTypes.ValidateFormES: {
            return {
                ...state,
                pending: true,
                error: 'Successfully validated!'
            }
        }

        case PaymentCheckActionTypes.LoadFormESForUploadState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormESForUploadStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormESData === null || state.sentOeBSFormESData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                forUploadFormESData: action.payload
            };
        }

        case PaymentCheckActionTypes.SendToOeBSFormES: {
            return {
                ...state,
                pending: true,
                error: 'Successfully uploaded to OeBS!'
            }
        }

        case PaymentCheckActionTypes.LoadFormESSentToOeBSState: {
            return {
                ...state,
                pending: true
            };
        }

        case PaymentCheckActionTypes.LoadFormESSentToOeBSStateSuccess: {
            return {
                ...state,
                pending: state.pendingValidateFormESData === null || state.forUploadFormESData === null
                    || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
                    || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
                    || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
                // || state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
                sentOeBSFormESData: action.payload
            };
        }

        // other
        case PaymentCheckActionTypes.LoadPaymentCheckStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }
        case PaymentCheckActionTypes.ValidateFail:
        case PaymentCheckActionTypes.UploadFail: {
            return {
                ...state,
                error: action.payload
            };
        }

        case PaymentCheckActionTypes.PaymentCheckScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }
        case PaymentCheckActionTypes.LoadInitPaymentCheckState: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;

export const getPendingValidateData = (state: State) => state.pendingValidateData;
export const getForUploadData = (state: State) => state.forUploadData;
export const getSentOeBSData = (state: State) => state.sentOeBSData;

export const getPendingValidateFormCGData = (state: State) => state.pendingValidateFormCGData;
export const getForUploadFormCGData = (state: State) => state.forUploadFormCGData;
export const getSentOeBSFormCGData = (state: State) => state.sentOeBSFormCGData;

export const getPendingValidateFormPPData = (state: State) => state.pendingValidateFormPPData;
export const getForUploadFormPPData = (state: State) => state.forUploadFormPPData;
export const getSentOeBSFormPPData = (state: State) => state.sentOeBSFormPPData;

export const getPendingValidateFormESData = (state: State) => state.pendingValidateFormESData;
export const getForUploadFormESData = (state: State) => state.forUploadFormESData;
export const getSentOeBSFormESData = (state: State) => state.sentOeBSFormESData;



// export const getPendingValidateFormCIData = (state: State) => state.pendingValidateFormCIData;
// export const getForUploadFormCIData = (state: State) => state.forUploadFormCIData;
// export const getSentOeBSFormCIData = (state: State) => state.sentOeBSFormCIData;







// // formCI
//         case PaymentCheckActionTypes.LoadFormCIForValidateInvoiveState: {
//     return {
//         ...state,
//         pending: true
//     };
// }

//         case PaymentCheckActionTypes.LoadFormCIForValidateInvoiveStateSuccess: {
//     return {
//         ...state,
//         pending: state.sentOeBSFormCIData === null || state.forUploadFormCIData === null
//             || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
//             || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
//             || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
//         pendingValidateFormCIData: action.payload
//     };
// }

//         case PaymentCheckActionTypes.ValidateFormCI: {
//     return {
//         ...state,
//         pending: true,
//         error: 'Successfully validated!'
//     }
// }

//         case PaymentCheckActionTypes.LoadFormCIForUploadState: {
//     return {
//         ...state,
//         pending: true
//     };
// }

//         case PaymentCheckActionTypes.LoadFormCIForUploadStateSuccess: {
//     return {
//         ...state,
//         pending: state.pendingValidateFormCIData === null || state.sentOeBSFormCIData === null
//             || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
//             || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
//             || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
//         forUploadFormCIData: action.payload
//     };
// }

//         case PaymentCheckActionTypes.SendToOeBSFormCI: {
//     return {
//         ...state,
//         pending: true,
//         error: 'Successfully uploaded to OeBS!'
//     }
// }

//         case PaymentCheckActionTypes.LoadFormCISentToOeBSState: {
//     return {
//         ...state,
//         pending: true
//     };
// }

//         case PaymentCheckActionTypes.LoadFormCISentToOeBSStateSuccess: {
//     return {
//         ...state,
//         error: null,
//         pending: state.pendingValidateFormCIData === null || state.forUploadFormCIData === null
//             || state.pendingValidateData === null || state.sentOeBSData === null || state.forUploadData === null
//             || state.pendingValidateFormCGData === null || state.sentOeBSFormCGData === null || state.forUploadFormCGData === null
//             || state.pendingValidateFormPPData === null || state.sentOeBSFormPPData === null || state.forUploadFormPPData === null,
//         sentOeBSFormCIData: action.payload
//     };
// }